import FilePickerViewState from '../store/schema/FilePickerViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { updateSupportedFilePickerActionsForProviderFiles } from './updateSupportedFilePickerActions';
import { action } from 'satcheljs/lib/legacy';

export default action('updateFileProviderItemsSelection')(function updateFileProviderItemsSelection(
    items: FileProviderItemViewState[],
    maxAllowedLocalFileSize: number,
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerViewState
) {
    items = items || [];
    viewState.selectedFileProviderItems = items;
    updateSupportedFilePickerActionsForProviderFiles(
        items,
        maxAllowedLocalFileSize,
        selectedFileProvider,
        viewState
    );
});
